<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Type:</label>

        <select name="Type" v-model="encodingData.Type" class="form-control">
          transportationtype
          <option value>Select Type</option>
          <option
            v-for="option in types"
            v-bind:value="option.transportationType"
            v-bind:key="option.transportationType"
          >{{option.transportationType}}</option>
        </select>

        <label>PrincipalId :</label>

        <input name="PrincipalId"
        v-validate="'max:50'"
        v-model="encodingData.PrincipalId" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('PrincipalId') }" />
                    <span v-if="submitted && errors.has('PrincipalId')"
                         class="invalid-feedback">
                        {{ errors.first("PrincipalId") }}
                    </span>

        <label>Name :</label>

        <input name="Name" 
        v-validate="'max:50'"
        v-model="encodingData.Name" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Name') }" />
                    <span v-if="submitted && errors.has('Name')"
                         class="invalid-feedback">
                        {{ errors.first("Name") }}
                    </span>

        <label>AdditionalId :</label>

        <input name="AdditionalId"
        v-validate="'max:50'"
        v-model="encodingData.AdditionalId" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('AdditionalId') }" />
                    <span v-if="submitted && errors.has('AdditionalId')"
                         class="invalid-feedback">
                        {{ errors.first("AdditionalId") }}
                    </span>

        <label>Make :</label>

        <input name="Make"
        v-validate="'max:50'"
        v-model="encodingData.Make" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Make') }" />
                    <span v-if="submitted && errors.has('Make')"
                         class="invalid-feedback">
                        {{ errors.first("Make") }}
                    </span>

        <label>Model :</label>

        <input name="Model" 
        v-validate="'max:50'"
        v-model="encodingData.Model" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Model') }" />
                    <span v-if="submitted && errors.has('Model')"
                         class="invalid-feedback">
                        {{ errors.first("Make") }}
                    </span>


        <label>ModelYear :</label>

        <input type="number"
        v-validate="'max:50'"
        name="ModelYear" 
        v-model="encodingData.ModelYear" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('ModelYear') }" />
                    <span v-if="submitted && errors.has('ModelYear')"
                         class="invalid-feedback">
                        {{ errors.first("ModelYear") }}
                    </span>

        <label>Color :</label>

        <input name="Color"
        v-validate="'max:50'"
        v-model="encodingData.Color" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Color') }" />
                    <span v-if="submitted && errors.has('Color')"
                         class="invalid-feedback">
                        {{ errors.first("Color") }}
                    </span>

        <label>Comments</label>
        <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />
      </div>
      <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageTransportationType,
  getlocalstorageCountry,
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        TransportationId: '',
        PrincipalId: '',
        Type: '',
        Name: '',
        AdditionalId: '',
        Make: '',
        Model: '',
        ModelYear: '',
        Color: '',
        Country: '',
        Comments: ''
      },
      countries: [],
      types: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.types = getlocalstorageTransportationType()
     
      this.getTransportation()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updateTransportation', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-trans')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getTransportation() {
      
      instance
        .get(DataURL + 'transportation?transportationID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.TransportationId = data.transportationId
              this.encodingData.PrincipalId = data.principalId
              this.encodingData.Type = data.type
              this.encodingData.Name = data.name
              this.encodingData.AdditionalId = data.additionalId
              this.encodingData.Make = data.make
              this.encodingData.Model = data.model
              this.encodingData.ModelYear = data.modelYear
              this.encodingData.Color = data.color
              this.encodingData.Country = data.country
              this.encodingData.Comments = data.comments
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
